module.exports = __webpack_public_path__ + "img/select-module.9cf69704.png";